import { useSelector } from 'react-redux';

import UpsaleMainModal from 'pages/paymentSuccess/upsaleModal';
import { UpsaleSuccessModal } from 'pages/paymentSuccess/upsaleModal/successModal';

import { AreYouSureLeavePageModal } from 'components/modals/areYouSureLeavePage';
import { CancelCouponSuccessModalABCFc2y1 } from 'components/modals/cancelCouponSuccessModalABCFc2y1 ';
import CheckYourEmailModal from 'components/modals/checkYourEmailModal';
import ChooseFormatAndConvertModal from 'components/modals/chooseFormatAndConvertModal';
import ChooseFormatAndParseTextModal from 'components/modals/chooseFormatAndParseTextModal';
import ChooseFormatImportExportEditor244Modal from 'components/modals/chooseFormatImportExportEditor244BModal';
import ChooseFormatModal from 'components/modals/chooseFormatModal';
import ChoseTranslateFormatModal from 'components/modals/choseTranslateFormatModal';
import { CompressModal } from 'components/modals/compressModal';
import DeleteDocumentModal from 'components/modals/deleteDocumentModal';
import DeleteFilesModal from 'components/modals/deleteFilesModal';
import EnterEmailAddressModal from 'components/modals/enterEmailAddressModal';
import EnterEmailAiSummarizerModal from 'components/modals/enterEmailAiSummarizerModal';
import EnterEmailTranslateModal from 'components/modals/enterEmailTranslateModal';
import FileUploadErrorModal from 'components/modals/fileErrorModal';
import ForgotPasswordModal from 'components/modals/forgotPasswordModal';
import GetFreeAccessModal from 'components/modals/getFreeAccessModal';
import MergeFiles from 'components/modals/mergeFiles';
import { MergePdfFilePreviewModal } from 'components/modals/mergePdfFilePreviewModal';
import PaymentErrorModal from 'components/modals/paymentErrorModal';
import ProgressEditFileModal from 'components/modals/progressEditFileModal';
import ProgressEditFileModalMobileEditor30 from 'components/modals/progressEditFileModalMobileEditor30';
import ProgressFileModal from 'components/modals/progressFileModal';
import ProgressModifyFileModal from 'components/modals/progressModifyFileModal';
import ProcessingTranslateModal from 'components/modals/progressTranslateModal';
import { RemoveWatermarkModal } from 'components/modals/removeWatermarkModal';
import { RemoveWatermarkProgressModal } from 'components/modals/removeWatermarkProgressModal';
import ThankYouPaymentModal from 'components/modals/thankYouPaymentModal';
import TrustPilotModal from 'components/modals/trustPilotModal';
import UnderDevelopmentModal from 'components/modals/underDevelopmentModal';

import { modalsSelector } from 'data/selectors/modals';

import { EModalTypes } from 'ts/enums/modal.types';

import RenameFile from '../modals/renameFile';
import { SendFileViaEmail } from '../modals/sendFileViaEmail';
import { ShareFileLinkModal } from '../modals/shareLink';

const ModalsController = () => {
  const { type } = useSelector(modalsSelector);

  switch (type) {
    case EModalTypes.PROGRESS_FILE:
      return <ProgressFileModal />;

    case EModalTypes.PROGRESS_EDIT_FILE:
      return <ProgressEditFileModal />;

    case EModalTypes.ENTER_EMAIL_ADDRESS:
      return <EnterEmailAddressModal />;

    case EModalTypes.ENTER_EMAIL_AI_SUMMARIZER:
      return <EnterEmailAiSummarizerModal />;

    case EModalTypes.DELETE_DOCUMENT:
      return <DeleteDocumentModal />;

    case EModalTypes.CHECK_YOUR_EMAIL:
      return <CheckYourEmailModal />;

    case EModalTypes.PAYMENT_ERROR:
      return <PaymentErrorModal />;

    case EModalTypes.FILE_UPLOAD_ERROR:
      return <FileUploadErrorModal />;

    case EModalTypes.THANK_YOU_PAYMENT:
      return <ThankYouPaymentModal />;

    case EModalTypes.CHOOSE_FORMAT:
      return <ChooseFormatModal />;

    case EModalTypes.CHOOSE_FORMAT_IMPORT_EXPORT_EDITOR_244:
      return <ChooseFormatImportExportEditor244Modal />;

    case EModalTypes.CHOOSE_FORMAT_AND_CONVERT:
      return <ChooseFormatAndConvertModal />;

    case EModalTypes.PROCESSING_COMPRESS:
      return <ProgressModifyFileModal type='compress' />;

    case EModalTypes.PROCESSING_SPLIT:
      return <ProgressModifyFileModal type='split' />;

    case EModalTypes.TRUST_PILOT:
      return <TrustPilotModal />;

    case EModalTypes.PROCESSING_MERGE:
      return <ProgressModifyFileModal type='merge' />;

    case EModalTypes.GET_FREE_ACCESS:
      return <GetFreeAccessModal />;

    case EModalTypes.FORGOT_PASSWORD:
      return <ForgotPasswordModal />;

    case EModalTypes.CHOOSE_FORMAT_AND_PARSE_TEXT:
      return <ChooseFormatAndParseTextModal />;

    case EModalTypes.CHOSE_TRANSLATE_FORMAT:
      return <ChoseTranslateFormatModal />;

    case EModalTypes.PROGRESS_TRANSLATE_FILE:
      return <ProcessingTranslateModal />;

    case EModalTypes.ENTER_EMAIL_TRANSLATE:
      return <EnterEmailTranslateModal />;

    case EModalTypes.MERGE_FILES:
      return <MergeFiles />;

    case EModalTypes.SHARE_FILE_LINK:
      return <ShareFileLinkModal />;

    case EModalTypes.SEND_FILE_VIA_EMAIL:
      return <SendFileViaEmail />;

    case EModalTypes.UNDER_DEVELOPMENT:
      return <UnderDevelopmentModal />;

    case EModalTypes.RENAME_FILE:
      return <RenameFile />;

    case EModalTypes.DELETE_FILES:
      return <DeleteFilesModal />;

    case EModalTypes.MERGE_PDF_FILE_PREVIEW_MODAL:
      return <MergePdfFilePreviewModal />;

    case EModalTypes.ARE_YOU_SURE_LEAVE_PAGE:
      return <AreYouSureLeavePageModal />;

    case EModalTypes.CHOOSE_COMPRESSION_LEVEL:
      return <CompressModal />;

    case EModalTypes.CANCEL_COUPON_SUCCESS_ABC_FC_2_Y_1:
      return <CancelCouponSuccessModalABCFc2y1 />;
    case EModalTypes.PROGRESS_EDIT_FILE_MOBILE_EDITOR_3_0:
      return <ProgressEditFileModalMobileEditor30 />;

    case EModalTypes.UPSALE:
      return <UpsaleMainModal />;

    case EModalTypes.UPSALE_SUCCESS:
      return <UpsaleSuccessModal />;

    case EModalTypes.PROGRESS_REMOVE_WATERMARK:
      return <RemoveWatermarkProgressModal />;

    case EModalTypes.REMOVE_WATERMARK:
      return <RemoveWatermarkModal />;

    default:
      return null;
  }
};

export default ModalsController;
